import { GroupedAgeGroupToYearsResults } from "@/dashboard-api-types/api/epidemiologyData.types";

type colors = "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";

interface options {
  stacked?: boolean;
  labels?: string[];
  yAxisID?: string[];
}

export const formatGroupedDataToChart = (
  groupedData: GroupedAgeGroupToYearsResults,
  options?: options
) => {
  const { stacked = false, labels, yAxisID } = options || {};
  const ageGroups = Object.keys(groupedData ?? {});
  const colors: colors[] = ["info", "error", "warning", "secondary"];
  return {
    labels: Object.keys(groupedData?.[ageGroups[0]] ?? {}),
    datasets: ageGroups
      .filter((ageGroup) => (stacked ? ageGroup != "total" : true))
      .map((ageGroup, index) => {
        return {
          label: labels ? labels[index] : ageGroup,
          color: colors[index % colors.length],
          data: Object.values(groupedData?.[ageGroup] ?? {}).map((e: any) => e?.value) || [],
          yAxisID: yAxisID ? yAxisID[index % yAxisID.length] : undefined,
        };
      }),
  };
};
